export { typography as typographyDesktop } from './desktop';
export { typography as typographyMobile } from './mobile';

export const characterWidth = 7.1;
